import React, { useState } from "react";
import Modal from "react-modal";

// Set the app element for accessibility
Modal.setAppElement("#root"); // Ensure you replace '#root' with your main app container

interface DescriptionWithModalProps {
  data: string | null; // Specify the expected type of `data`
  dataIndex: number;
}

const DescriptionWithModal: React.FC<DescriptionWithModalProps> = ({
  data,
  dataIndex,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false); // State to control modal visibility

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const customStyles:any = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      background: "unset !importent",
      padding: "0 !important",
      border: "none !important",
      width: "500px",
      textAlign: "right" 
    },
  };

  return (
    <td>
      <img className="jehsdfhw"
        onClick={openModal} 
        src={data ? data : "/assets/img/explore_placeholder.png"}
        alt=""
      />

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Image Modal"
        style={customStyles}
      >
        <i
          className="fa fa-times-circled fa-trash-css"
          onClick={closeModal}
          role="button"
        ></i>

        <img
          src={data ? data : "/assets/img/explore_placeholder.png"}
          alt=""
          style={{
            maxWidth: "100%",
            maxHeight: "80vh",
            objectFit: "contain",
          }}
          className="modal-image"
        />
      </Modal>
    </td>
  );
};

export default DescriptionWithModal;
